import { useMobileOrientation, isMobileOnly } from "react-device-detect";
import CreativeComponent from "components/atoms/CreativeComponent";
import ctvTV from "../../../assets/tv.png";
import "./Ctv.scss";

const Ctv = () => {
  const { isLandscape } = useMobileOrientation(); // TODO: maybe similar to screenSizeClass
  const cssLandscape = isLandscape ? 'landscape' : '';
  const cssMobile = isMobileOnly ? 'mobile' : '';

  return (
    <div className={`ctv-view-container  ${cssLandscape} ${cssMobile}`}>
      <img src={ctvTV} alt="" />
      <div className="ctv-video-wrapper">
        <CreativeComponent width={'100%'} height={'100%'}/>
      </div>
    </div>
  );
};

export default Ctv;
